/* ============================================================================
   AARUSH, Storefront interactions for Shopify OS 2.0
   Ported from the prototype app.js. Data + geo pricing removed (now Shopify
   objects + Markets). Cart is the native AJAX cart via the Section Rendering
   API. Wishlist stays client-side (localStorage). Theme, reveal, sliders,
   drawer, PDP gallery, buybar, accordion, search all carry over unchanged.
   ============================================================================ */
(function(){
  "use strict";
  var S = window.AARUSH_SETTINGS || {};
  var routes = S.routes || {};
  var $  = function(s,c){ return (c||document).querySelector(s); };
  var $$ = function(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };
  var store = {
    get:function(k,d){ try{ var v=JSON.parse(localStorage.getItem(k)); return v==null?d:v; }catch(e){ return d; } },
    set:function(k,v){ try{ localStorage.setItem(k,JSON.stringify(v)); }catch(e){} }
  };

  /* ---------------------------------------------------------------- THEME */
  var root = document.documentElement;
  function applyTheme(t){ root.setAttribute("data-theme", t); store.set("aarush-theme", t); }
  document.addEventListener("click", function(e){
    if(e.target.closest("[data-theme-toggle]")){
      applyTheme(root.getAttribute("data-theme")==="dark" ? "light" : "dark");
    }
  });

  /* ------------------------------------------------------------- OVERLAYS */
  function lock(){ document.body.style.overflow="hidden"; }
  function unlock(){ document.body.style.overflow=""; }
  function openDrawer(){ var d=$("[data-cart-drawer]"); if(d) d.classList.add("open"); var o=$("[data-overlay]"); if(o) o.classList.add("open"); lock(); }
  function openMnav(){ var m=$("[data-mnav]"); if(m) m.classList.add("open"); var o=$("[data-overlay]"); if(o) o.classList.add("open"); lock(); }
  function openFilters(){ var f=$("[data-filters]"); if(f) f.classList.add("open"); var o=$("[data-overlay]"); if(o) o.classList.add("open"); lock(); }
  function closeAll(){ $$(".drawer,.mnav,.filters").forEach(function(d){ d.classList.remove("open"); }); var o=$("[data-overlay]"); if(o) o.classList.remove("open"); unlock(); if(window.__feedCloseLB) window.__feedCloseLB(); }
  window.closeAll = closeAll;

  /* --------------------------------------------------------------- TOAST */
  function toast(msg, ok){
    var wrap = $("[data-toast-wrap]");
    if(!wrap){ wrap = document.createElement("div"); wrap.className="toast-wrap"; wrap.setAttribute("data-toast-wrap",""); document.body.appendChild(wrap); }
    var t = document.createElement("div"); t.className = "toast" + (ok?" ok":"");
    t.innerHTML = '<span class="em">'+(ok?"✓":"ℹ")+'</span> ' + msg;
    wrap.appendChild(t);
    setTimeout(function(){ t.style.transition="opacity .3s, transform .3s"; t.style.opacity="0"; t.style.transform="translateY(10px)"; setTimeout(function(){ t.remove(); },300); }, 2600);
  }
  window.AarushToast = toast;

  /* ----------------------------------------------------------- AJAX CART */
  function bumpCount(n){ $$("[data-cart-count]").forEach(function(el){ el.textContent = n; el.dataset.count = n; }); }

  function refreshDrawer(sectionsHTML){
    if(sectionsHTML && sectionsHTML["cart-drawer"]){
      var doc = new DOMParser().parseFromString(sectionsHTML["cart-drawer"], "text/html");
      var fresh = doc.querySelector("[data-cart-drawer]");
      var current = $("[data-cart-drawer]");
      if(fresh && current) current.innerHTML = fresh.innerHTML;
    }
  }

  function addToCart(variantId, qty){
    qty = qty || 1;
    return fetch(routes.cart_add, {
      method:"POST",
      headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ items:[{ id: variantId, quantity: qty }], sections:["cart-drawer"], sections_url: location.pathname })
    })
    .then(function(r){ return r.json(); })
    .then(function(data){
      if(data.status){ toast(data.description || "Could not add to basket"); return; }
      refreshDrawer(data.sections);
      var title = (data.items && data.items[0] && data.items[0].product_title) || "Added";
      updateCount().then(function(){
        toast("Added · " + title, true);
        if(S.cartDrawer !== false) openDrawer();
      });
    })
    .catch(function(){ toast("Could not add to basket"); });
  }

  function changeLine(key, quantity){
    return fetch(routes.cart_change, {
      method:"POST",
      headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ id: key, quantity: quantity, sections:["cart-drawer"], sections_url: location.pathname })
    })
    .then(function(r){ return r.json(); })
    .then(function(data){
      refreshDrawer(data.sections);
      bumpCount(data.item_count);
      if($("[data-cart-page]")) location.reload();
      return data;
    });
  }

  function updateCount(){
    return fetch(routes.cart, { headers:{ "Accept":"application/json" } })
      .then(function(r){ return r.json(); })
      .then(function(c){ bumpCount(c.item_count); return c; });
  }

  /* ------------------------------------------------- MINIMUM BASKET SIZE */
  /* snippets/cart-min.liquid only renders [data-min-note] while the basket is
     under the minimum, so its presence means "checkout is blocked". The submit
     button is already disabled server side; this also catches an Enter keypress
     inside the cart form, which submits without going through the button. */
  document.addEventListener("submit", function(e){
    var form = e.target.closest("[data-cart-page]");
    if(!form) return;
    var note = form.querySelector("[data-min-note]");
    if(!note) return;
    e.preventDefault();
    toast(note.getAttribute("data-min-msg") || "Add more items to check out");
    note.scrollIntoView({ behavior:"smooth", block:"center" });
  });

  /* ------------------------------------------------------------- WISHLIST */
  var favs = store.get("aarush-favs", []);
  function toggleFav(handle){
    var i = favs.indexOf(handle);
    if(i>=0){ favs.splice(i,1); toast("Removed from wishlist"); }
    else { favs.push(handle); toast("Saved to wishlist", true); }
    store.set("aarush-favs", favs);
    $$('[data-fav="'+handle+'"]').forEach(function(b){ b.classList.toggle("active", favs.indexOf(handle)>=0); });
    var stat = $("[data-wl-stat]"); if(stat) stat.textContent = favs.length;
    if($("[data-wishlist-grid]")) renderWishlist();
  }
  function markFavs(){ $$("[data-fav]").forEach(function(b){ b.classList.toggle("active", favs.indexOf(b.dataset.fav)>=0); }); }

  function renderWishlist(){
    var grid = $("[data-wishlist-grid]"); if(!grid) return;
    var empty = $("[data-wishlist-empty]");
    var count = $("[data-wl-count]");
    if(!favs.length){ grid.innerHTML=""; if(empty) empty.classList.remove("hidden"); if(count) count.textContent="The snacks you love, kept in one place."; return; }
    if(empty) empty.classList.add("hidden");
    if(count) count.textContent = favs.length + " item" + (favs.length>1?"s":"") + " saved.";
    Promise.all(favs.map(function(h){
      return fetch("/products/"+h+".js").then(function(r){ return r.ok?r.json():null; }).catch(function(){ return null; });
    })).then(function(list){
      grid.innerHTML = list.filter(Boolean).map(wishCard).join("");
      if(window.__revealRescan) window.__revealRescan();
    });
  }
  function wishCard(p){
    var v = p.variants[0];
    var img = p.featured_image ? '<img src="'+p.featured_image+'" alt="'+escapeHtml(p.title)+'" class="ph-img" loading="lazy">'
      : '<div class="ph"><svg class="ph-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="3" y="3" width="18" height="18" rx="2.5"/><circle cx="8.5" cy="9" r="1.6"/><path d="M21 14.5 16 9.5 5 20.5"/></svg></div>';
    return '<article class="pcard" data-id="'+p.id+'" data-handle="'+p.handle+'">'+
      '<div class="pcard-media">'+
        '<button class="pcard-fav active" data-fav="'+p.handle+'" aria-label="Save to wishlist" type="button"><svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg></button>'+
        '<a href="'+p.url+'">'+img+'</a>'+
        '<div class="pcard-quick"><button class="btn btn--cta btn--sm btn--block" data-add="'+v.id+'" type="button">Add to basket</button></div>'+
      '</div>'+
      '<div class="pcard-body">'+
        '<span class="pcard-cat">'+(p.type||"")+'</span>'+
        '<h3 class="pcard-title"><a href="'+p.url+'">'+escapeHtml(p.title)+'</a></h3>'+
        '<div class="pcard-foot"><div class="price"><span class="now">'+formatMoney(v.price)+'</span></div>'+
        '<button class="add-btn" data-add="'+v.id+'" type="button"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg></button></div>'+
      '</div></article>';
  }
  function escapeHtml(s){ return String(s).replace(/[&<>"]/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }
  function formatMoney(cents){
    var fmt = S.moneyFormat || "${{amount}}";
    var amount = (cents/100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents/100));
  }

  /* ------------------------------------------------------- GLOBAL CLICKS */
  document.addEventListener("click", function(e){
    var t = e.target;
    var add = t.closest("[data-add]");
    if(add){ e.preventDefault(); addToCart(add.dataset.add, 1); return; }
    var fav = t.closest("[data-fav]");
    if(fav){ e.preventDefault(); toggleFav(fav.dataset.fav); return; }
    var copyBtn = t.closest("[data-copy-code]");
    if(copyBtn){
      e.preventDefault();
      var code = copyBtn.querySelector("span") ? copyBtn.querySelector("span").textContent.trim() : "";
      var hint = copyBtn.querySelector("[data-copy-hint]");
      var done = function(){ copyBtn.classList.add("copied"); if(hint) hint.textContent = "Copied"; };
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(code).then(done).catch(function(){ done(); });
      } else { done(); }
      return;
    }
    if(t.closest("[data-open-cart]")){ e.preventDefault(); openDrawer(); return; }
    if(t.closest("[data-open-menu]")){ openMnav(); return; }
    if(t.closest("[data-open-filters]")){ openFilters(); return; }
    if(t.closest("[data-close]") || t.closest("[data-overlay]")){ closeAll(); return; }
    var rm = t.closest("[data-rm]");
    if(rm){ e.preventDefault(); changeLine(rm.dataset.rm, 0); return; }
    var qb = t.closest("[data-qty-key]");
    if(qb){ e.preventDefault(); changeLine(qb.dataset.qtyKey, parseInt(qb.dataset.qty,10)); return; }
    // country switcher
    if(t.closest("[data-country-toggle]")){ t.closest(".country").classList.toggle("open"); }
    else $$(".country.open").forEach(function(c){ if(!c.contains(t)) c.classList.remove("open"); });
  });
  addEventListener("keydown", function(e){ if(e.key==="Escape") closeAll(); });

  /* ------------------------------------------------ NEWSLETTER (flip, no reload) */
  document.addEventListener("submit", function(e){
    var form = e.target;
    if(!form.classList || !form.classList.contains("newsletter-form")) return;
    e.preventDefault();                       // never reload: the reload was wiping the code
    var wrap = form.closest("[data-newsletter]");
    var btn = form.querySelector("[type=submit]");
    if(btn) btn.disabled = true;
    if(wrap) wrap.classList.add("is-flipped"); // flip immediately, code stays put
    // Subscribe in the background. We deliberately do NOT fall back to a native
    // submit on failure: a full-page POST reloads the section and the coupon
    // disappears. The code is shown regardless; the POST just records the signup.
    try{
      fetch(form.action, { method:"POST", body:new FormData(form), headers:{ "Accept":"application/json" } })
        .catch(function(){});
    }catch(_){}
  });

  /* --------------------------------------------------------- ACCORDION */
  document.addEventListener("click", function(e){
    var q = e.target.closest(".acc-q");
    if(q){ var item=q.closest(".acc-item"); var a=$(".acc-a",item);
      var open=item.classList.toggle("open"); a.style.maxHeight = open ? a.scrollHeight+"px" : 0; }
  });

  /* ------------------------------------------------------- SCROLL REVEAL */
  var io;
  function revealScan(scope){
    scope = scope || document;
    if(!io){ io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } }); }, {threshold:.12, rootMargin:"0px 0px -8% 0px"}); }
    $$(".reveal:not(.in)", scope).forEach(function(el){ io.observe(el); });
  }
  window.__revealRescan = function(){ revealScan(document); };

  /* ------------------------------------------------ COUNT-UP (metrics) */
  function countUps(){
    var els = $$(".stat b, .hero-trust .t b");
    if(!els.length || !("IntersectionObserver" in window)) return;
    var obs = new IntersectionObserver(function(es){ es.forEach(function(e){ if(!e.isIntersecting) return; obs.unobserve(e.target); animateCount(e.target); }); }, {threshold:.4});
    els.forEach(function(el){ obs.observe(el); });
  }
  function animateCount(el){
    var m = el.textContent.trim().match(/^(\D*)(\d[\d,]*)(.*)$/);
    if(!m) return;
    var pre=m[1], target=parseInt(m[2].replace(/,/g,""),10), suf=m[3];
    if(!target || target>100000) return;
    /* Group with commas only if the authored value was already grouped, so a year
       ("1999") never animates into "1,999" while a real count ("1,200") keeps it. */
    var grouped=m[2].indexOf(",")>-1;
    var dur=1100, t0=performance.now();
    el.textContent = pre + "0" + suf;
    (function tick(now){
      var p=Math.min(1,(now-t0)/dur), eased=1-Math.pow(1-p,3), n=Math.round(target*eased);
      el.textContent = pre + (grouped ? n.toLocaleString() : String(n)) + suf;
      if(p<1) requestAnimationFrame(tick);
    })(t0);
  }

  /* --------------------------------------------------- HEADER / STICKY */
  function stickyHeader(){
    var h=$(".header"); if(!h) return;
    var on=function(){ h.classList.toggle("is-stuck", window.scrollY>8); };
    on(); addEventListener("scroll", on, {passive:true});
  }
  function backToTop(){
    var b=$(".to-top"); if(!b) return;
    addEventListener("scroll", function(){ b.classList.toggle("show", window.scrollY>600); }, {passive:true});
    b.addEventListener("click", function(){ scrollTo({top:0,behavior:"smooth"}); });
  }
  var reduceMotion = function(){ return window.matchMedia && matchMedia("(prefers-reduced-motion:reduce)").matches; };

  /* ----------------------------------------------------- HERO SLIDER */
  function heroSlider(){
    var track=$(".hero-track"); var dots=$$(".hero-dots button");
    if(!track || !dots.length) return;
    var slides=$$("[data-hero-slide]", track);
    var i=0, timer;
    // Show one slide at a time at every width, so the hero height follows the
    // active slide's natural height (slide 1 stays a clean 4:5) instead of all
    // slides being stretched to a shared, locked height.
    function show(n){ slides.forEach(function(s,x){ s.style.display = x===n ? "" : "none"; }); }
    function mark(n){ i=n; dots.forEach(function(d,x){ d.classList.toggle("active", x===n); }); }
    function go(n){ n=(n+slides.length)%slides.length; mark(n); show(n); }
    function play(){ stop(); if(reduceMotion()) return; timer=setInterval(function(){ go(i+1); }, 5000); }
    function stop(){ clearInterval(timer); }
    dots.forEach(function(d,x){ d.addEventListener("click", function(){ go(x); play(); }); });
    var prevBtn=$("[data-hero-prev]"), nextBtn=$("[data-hero-next]");
    if(prevBtn) prevBtn.addEventListener("click", function(){ go(i-1); play(); });
    if(nextBtn) nextBtn.addEventListener("click", function(){ go(i+1); play(); });
    mark(0); show(0); play();
  }

  /* -------------------------------------------------- PDP SWIPE GALLERY */
  function initGallery(){
    var main=$(".pdp-main"); if(!main) return;
    var track=$(".pdp-track", main); if(!track) return;
    var slides=$$(".pdp-slide", track); if(!slides.length) return;
    var dots=$$(".pdp-dots button", main);
    var thumbsWrap=$(".pdp-thumbs");
    var thumbs=thumbsWrap ? $$("button", thumbsWrap) : [];
    var prev=$(".pdp-nav.prev", main), next=$(".pdp-nav.next", main);
    var at=function(){ return Math.round(track.scrollLeft/track.clientWidth); };
    function to(n){ n=Math.max(0,Math.min(slides.length-1,n)); track.scrollTo({ left: track.clientWidth*n, behavior: reduceMotion()?"auto":"smooth" }); }
    function mark(n){ dots.forEach(function(d,x){ d.classList.toggle("active", x===n); }); thumbs.forEach(function(tb,x){ tb.classList.toggle("active", x===n); }); }
    if(prev) prev.addEventListener("click", function(){ to(at()-1); });
    if(next) next.addEventListener("click", function(){ to(at()+1); });
    dots.forEach(function(d,x){ d.addEventListener("click", function(){ mark(x); to(x); }); });
    thumbs.forEach(function(tb,x){ tb.addEventListener("click", function(e){ e.preventDefault(); mark(x); to(x); }); });
    if("IntersectionObserver" in window){
      var io2=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting) mark(slides.indexOf(e.target)); }); }, { root:track, threshold:.6 });
      slides.forEach(function(s){ io2.observe(s); });
    } else { track.addEventListener("scroll", function(){ mark(at()); }, {passive:true}); }
    mark(0);
  }

  /* ------------------------------------------------ HORIZONTAL SCROLLERS */
  function hookScrollers(){
    $$("[data-scroller]").forEach(function(wrap){
      var track=$(wrap.dataset.scroller, document) || $(".h-scroll, .cat-scroller, .reels", wrap);
      if(!track) return;
      var prev=$("[data-sc-prev]", wrap), next=$("[data-sc-next]", wrap);
      function step(dir){ track.scrollBy({left: dir*(track.clientWidth*.8), behavior:"smooth"}); }
      if(prev) prev.addEventListener("click", function(){ step(-1); });
      if(next) next.addEventListener("click", function(){ step(1); });
    });
  }

  /* --------------------------------------------------------- PDP LOGIC */
  function initProduct(){
    var rootEl=$("[data-product-root]"); if(!rootEl) return;
    var form=$("#ProductForm");
    var select=$("[data-variant-select]", rootEl);
    var qtyInput=$("[data-qty-input]", rootEl);
    var qtyVal=$("[data-qty-val]", rootEl);
    var qty=1;

    // quantity picker
    var picker=$("[data-qty-picker]", rootEl);
    if(picker) picker.addEventListener("click", function(e){
      var b=e.target.closest("[data-q]"); if(!b) return;
      qty=Math.max(1, qty + parseInt(b.dataset.q,10));
      if(qtyVal) qtyVal.textContent=qty; if(qtyInput) qtyInput.value=qty;
    });

    // option chips -> resolve variant
    function currentOptions(){
      return $$(".opt-chips", rootEl).map(function(group){
        var active=$(".opt-chip.active", group); return active?active.dataset.value:null;
      });
    }
    function resolveVariant(){
      if(!select) return;
      var opts=currentOptions();
      var match=null;
      $$("option", select).forEach(function(o){
        // option text is the variant title "a / b"; compare by joining chosen options
        if(o.textContent.trim() === opts.join(" / ")) match=o;
      });
      if(!match && opts.length===1){ $$("option", select).forEach(function(o){ if(o.textContent.trim()===opts[0]) match=o; }); }
      if(match){
        select.value=match.value;
        updatePrice(match);
      }
    }
    function updatePrice(opt){
      var avail = opt.getAttribute("data-available")==="true";
      $$("[data-price]").forEach(function(el){ if(opt.dataset.price) el.textContent=opt.dataset.price; });
      $$("[data-compare]").forEach(function(el){ if(opt.dataset.compare && opt.dataset.compare!=="") { el.textContent=opt.dataset.compare; el.style.display=""; } else el.style.display="none"; });
      var save=$("[data-save]"); if(save){ if(opt.dataset.save){ save.textContent="Save "+opt.dataset.save+"%"; save.style.display=""; } else save.style.display="none"; }
      var submit=$("[data-add-submit]"), label=$("[data-add-label]");
      if(submit){ submit.disabled=!avail; }
      if(label){ label.textContent = avail ? "Add to basket" : "Sold out"; }
    }
    $$(".opt-chips", rootEl).forEach(function(group){
      group.addEventListener("click", function(e){
        var chip=e.target.closest(".opt-chip"); if(!chip) return;
        $$(".opt-chip", group).forEach(function(c){ c.classList.remove("active"); });
        chip.classList.add("active");
        resolveVariant();
      });
    });

    // submit -> AJAX add
    if(form) form.addEventListener("submit", function(e){
      e.preventDefault();
      var id = select ? select.value : (form.querySelector("[name=id]") && form.querySelector("[name=id]").value);
      if(id) addToCart(id, qty);
    });
    // buybar mirrors form submit
    var buybar=$("[data-buybar-add]");
    if(buybar) buybar.addEventListener("click", function(){ var id=select?select.value:null; if(id) addToCart(id, qty); });

    initGallery();
  }

  /* -------------------------------------------------- ACCORDION SEEDING */
  /* .acc-a is max-height:0 by default, so any row that ships already .open
     must have its height seeded or it renders collapsed despite the class. */
  function seedAccordions(root){
    $$(".acc-item.open .acc-a", root || document).forEach(function(a){
      a.style.maxHeight = a.scrollHeight + "px";
    });
  }

  /* ------------------------------------------------------------- THE FEED
     Curated social wall: masonry, shoppable hotspots, immersive lightbox.

     Unlike the prototype, cards are rendered server-side by feed-card.liquid,
     so there is no data model here. The lightbox clones each card's
     <template class="feed-full">, which keeps Shopify money formatting and
     real variant ids intact. Add buttons just emit [data-add] and the global
     click handler does the rest, no parallel cart logic. */
  var feedState = { tag:"All", shown:0, per:8, cards:[], lbIndex:-1, imgIndex:0, lastFocus:null };

  /* a card is single-image or a carousel; the image list is serialised onto
     data-feed-images by feed-card.liquid, cover falls back to the visible img */
  function feedImages(card){
    var raw = card.getAttribute("data-feed-images");
    if(raw){ try{ var a = JSON.parse(raw); if(a && a.length) return a; }catch(e){} }
    var img = $(".feed-media img", card);
    return img ? [img.currentSrc || img.src] : [];
  }

  function feedCards(){
    var wall = $("[data-feed-wall]");
    return wall ? $$(".feed-card", wall) : [];
  }
  /* cards currently passing the tag filter, in DOM order */
  function feedVisible(){
    return feedCards().filter(function(c){ return !c.hasAttribute("data-filtered"); });
  }

  /* --- masonry span maths ------------------------------------------------
     Cards are content-height (align-items:start) so measuring never feeds
     back into itself. Media height comes from the authored ratio on --ar,
     not from the loaded image, which is why the wall has no layout shift. */
  function layoutWall(){
    var wall = $("[data-feed-wall]"); if(!wall) return;
    var cs = getComputedStyle(wall);
    var row = parseFloat(cs.getPropertyValue("--feed-row")) || 8;
    var gap = parseFloat(cs.columnGap) || 20;
    feedCards().forEach(function(card){
      if(card.style.display === "none") return;
      var h = card.getBoundingClientRect().height;
      if(h > 0) card.style.setProperty("--span", Math.ceil((h + gap)/row));
    });
  }

  function feedApply(){
    var wall = $("[data-feed-wall]"); if(!wall) return;
    var shownCount = 0;
    feedCards().forEach(function(card){
      var tag = (($(".feed-tag", card) || {}).textContent || "").trim();
      var match = feedState.tag === "All" || tag === feedState.tag;
      if(!match){
        card.setAttribute("data-filtered","");
        card.style.display = "none";
        return;
      }
      card.removeAttribute("data-filtered");
      shownCount++;
      card.style.display = (feedState.shown && shownCount > feedState.shown) ? "none" : "";
    });
    var total = feedVisible().length;
    var count = $("[data-feed-count]");
    if(count) count.textContent = total + (total === 1 ? " post" : " posts");
    var more = $("[data-feed-more-link]");
    if(more && feedState.shown) more.hidden = feedState.shown >= total;
    layoutWall();
    revealScan(wall);
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(layoutWall);
  }

  /* --- lightbox ---------------------------------------------------------- */
  function feedLbEl(){
    var el = $("[data-feed-lb]");
    if(el) return el;
    el = document.createElement("div");
    el.className = "feed-lb";
    el.setAttribute("data-feed-lb","");
    el.setAttribute("role","dialog");
    el.setAttribute("aria-modal","true");
    el.setAttribute("aria-label","Feed post");
    el.innerHTML =
      '<div class="feed-lb-panel">' +
        '<div class="feed-lb-media">' +
          '<button class="feed-lb-nav prev" data-lb-step="-1" type="button" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg></button>' +
          '<button class="feed-lb-nav next" data-lb-step="1" type="button" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg></button>' +
          '<img alt="">' +
          '<div class="feed-lb-dots" data-lb-dots></div>' +
        '</div>' +
        '<div class="feed-lb-side"></div>' +
        '<button class="feed-lb-close" data-lb-close type="button" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
      '</div>';
    document.body.appendChild(el);
    return el;
  }

  /* side panel + tint + dots, rebuilt only when the post changes */
  function feedRenderPost(card){
    var el = feedLbEl();
    var media = $(".feed-lb-media", el);
    var tint = card.style.getPropertyValue("--tint");
    media.style.background = tint || "";
    media.classList.toggle("is-tinted", !!tint);
    var imgs = feedImages(card);
    var dots = "";
    if(imgs.length > 1){
      for(var k=0;k<imgs.length;k++){
        dots += '<button data-lb-dot="' + k + '" type="button" aria-label="Photo ' + (k+1) + ' of ' + imgs.length + '"></button>';
      }
    }
    $("[data-lb-dots]", el).innerHTML = dots;
    var tpl = $(".feed-full", card);
    $(".feed-lb-side", el).innerHTML = tpl ? tpl.innerHTML : "";
  }

  /* the whole visible feed is one continuous flow of slides */
  function feedAtStart(){ return feedState.lbIndex <= 0 && feedState.imgIndex <= 0; }
  function feedAtEnd(){
    var list = feedVisible();
    var card = list[feedState.lbIndex];
    return feedState.lbIndex >= list.length - 1 && feedState.imgIndex >= feedImages(card).length - 1;
  }

  function feedShowImage(card, idx){
    var el = feedLbEl();
    var media = $(".feed-lb-media", el);
    var img = $("img", media);
    var imgs = feedImages(card);
    idx = Math.max(0, Math.min(imgs.length - 1, idx));
    feedState.imgIndex = idx;
    function swap(){ img.src = imgs[idx]; img.alt = ($(".feed-caption", card) || {}).textContent || ""; }
    if(!reduceMotion() && img.getAttribute("src") && img.getAttribute("src") !== imgs[idx]){
      media.classList.add("is-swapping");
      setTimeout(function(){
        if(!el.classList.contains("open")){ media.classList.remove("is-swapping"); return; }
        swap();
        requestAnimationFrame(function(){ media.classList.remove("is-swapping"); });
      }, 90);
    } else swap();
    $$("[data-lb-dot]", el).forEach(function(d,k){ d.classList.toggle("active", k === idx); });
    $(".feed-lb-nav.prev", el).disabled = feedAtStart();
    $(".feed-lb-nav.next", el).disabled = feedAtEnd();
  }

  function feedOpenLB(i, imgIdx, push){
    var list = feedVisible();
    var card = list[i]; if(!card) return;
    var el = feedLbEl();
    var first = !el.classList.contains("open");
    var postChanged = i !== feedState.lbIndex;
    if(first) feedState.lastFocus = document.activeElement;
    feedState.lbIndex = i;
    if(first || postChanged) feedRenderPost(card);
    feedShowImage(card, imgIdx || 0);

    el.classList.add("open");
    var ov = $("[data-overlay]"); if(ov) ov.classList.add("open");
    document.body.style.overflow = "hidden";

    if(push !== false){
      var hash = "#post-" + card.getAttribute("data-post");
      // One history entry for the whole lightbox session. Opening pushes,
      // moving on replaces. Otherwise Back walks posts backwards instead of
      // closing, and closing reopens the post before it.
      if(location.hash !== hash){
        if(first) history.pushState({feedPost:1}, "", hash);
        else history.replaceState({feedPost:1}, "", hash);
      }
    }
    if(first) setTimeout(function(){ var c = $(".feed-lb-close", el); if(c) c.focus(); }, 30);
  }

  function feedCloseLB(pop){
    var el = $("[data-feed-lb]");
    if(!el || !el.classList.contains("open")) return;
    el.classList.remove("open");
    var ov = $("[data-overlay]"); if(ov) ov.classList.remove("open");
    document.body.style.overflow = "";
    feedState.lbIndex = -1; feedState.imgIndex = 0;
    if(pop !== false && /^#post-/.test(location.hash)) history.back();
    if(feedState.lastFocus && feedState.lastFocus.focus){ feedState.lastFocus.focus(); feedState.lastFocus = null; }
  }
  window.__feedCloseLB = function(){ feedCloseLB(true); };

  /* advance within the carousel first, spill into the next post only once its
     images are exhausted */
  function feedStepLB(d){
    var list = feedVisible();
    var card = list[feedState.lbIndex]; if(!card) return;
    var ni = feedState.imgIndex + d;
    if(ni >= 0 && ni < feedImages(card).length){ feedShowImage(card, ni); return; }
    var np = feedState.lbIndex + (d > 0 ? 1 : -1);
    if(np < 0 || np >= list.length) return;
    feedOpenLB(np, d > 0 ? 0 : feedImages(list[np]).length - 1, true);
  }

  function feedShare(){
    var card = feedVisible()[feedState.lbIndex]; if(!card) return;
    var url = location.origin + location.pathname + "#post-" + card.getAttribute("data-post");
    var cap = ($(".feed-caption", card) || {}).textContent || "";
    if(navigator.share){ navigator.share({title:"Aarush", text:cap.slice(0,90), url:url}).catch(function(){}); return; }
    var done = function(){ toast("Link copied", true); };
    if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(url).then(done, done); }
    else done();
  }

  function feedCloseHotspots(){
    $$(".feed-pop.open").forEach(function(p){ p.classList.remove("open"); });
    $$('.feed-hotspot[aria-expanded="true"]').forEach(function(b){ b.setAttribute("aria-expanded","false"); });
  }

  function initFeed(){
    var wall = $("[data-feed-wall]"); if(!wall) return;
    feedState.per = parseInt(wall.getAttribute("data-feed-per") || "8", 10);
    feedState.shown = 0;   // server already paginated, show everything it sent
    // Liquid renders a plain responsive grid so the page works without JS.
    // Masonry (row spans, featured double-width) is opt-in from here.
    wall.classList.add("is-masonry");
    feedApply();

    $$("[data-feed-tag]").forEach(function(btn){
      btn.addEventListener("click", function(){
        var tag = btn.getAttribute("data-feed-tag");
        if(tag === feedState.tag) return;
        feedState.tag = tag;
        $$("[data-feed-tag]").forEach(function(b){ b.classList.toggle("tag--active", b === btn); });
        if(reduceMotion()){ feedApply(); return; }
        feedVisible().forEach(function(c){ c.classList.add("is-out"); });
        setTimeout(function(){
          feedCards().forEach(function(c){ c.classList.remove("is-out"); });
          feedApply();
        }, 200);
      });
    });

    wall.addEventListener("click", function(e){
      var spot = e.target.closest("[data-hotspot]");
      if(spot){
        e.preventDefault(); e.stopPropagation();
        var media = spot.closest(".feed-media");
        var pop = $('[data-pop="' + spot.getAttribute("data-hotspot") + '"]', media);
        var wasOpen = pop.classList.contains("open");
        feedCloseHotspots();
        if(!wasOpen){
          pop.classList.add("open");
          spot.setAttribute("aria-expanded","true");
          pop.classList.toggle("flip-down", pop.getBoundingClientRect().top < 8);
        }
        return;
      }
      if(e.target.closest(".feed-pop")) return;   // let [data-add] bubble
      var open = e.target.closest("[data-open-post]");
      if(open){
        e.preventDefault();
        feedCloseHotspots();
        var idx = feedVisible().indexOf(open.closest(".feed-card"));
        if(idx >= 0) feedOpenLB(idx, 0, true);
      }
    });

    document.addEventListener("click", function(e){
      if(e.target.closest("[data-lb-close]")){ e.preventDefault(); feedCloseLB(true); return; }
      var step = e.target.closest("[data-lb-step]");
      if(step){ e.preventDefault(); feedStepLB(parseInt(step.getAttribute("data-lb-step"),10)); return; }
      var dot = e.target.closest("[data-lb-dot]");
      if(dot){ e.preventDefault(); var c = feedVisible()[feedState.lbIndex]; if(c) feedShowImage(c, parseInt(dot.getAttribute("data-lb-dot"),10)); return; }
      if(e.target.closest("[data-lb-share]")){ e.preventDefault(); feedShare(); return; }
      var lb = $("[data-feed-lb]");
      if(lb && lb.classList.contains("open") && e.target === lb){ feedCloseLB(true); return; }
      if(!e.target.closest(".feed-media")) feedCloseHotspots();
    });

    addEventListener("keydown", function(e){
      // Escape dismisses a hotspot popover, closeAll only knows about panels
      if(e.key === "Escape" && $(".feed-pop.open")){ feedCloseHotspots(); return; }
      var lb = $("[data-feed-lb]");
      if(!lb || !lb.classList.contains("open")) return;
      if(e.key === "ArrowLeft"){ e.preventDefault(); feedStepLB(-1); }
      else if(e.key === "ArrowRight"){ e.preventDefault(); feedStepLB(1); }
      else if(e.key === "Tab"){
        var f = $$('button:not([disabled]), a[href]', lb);
        if(!f.length) return;
        var first = f[0], last = f[f.length-1];
        if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      }
    });

    var sx = 0, sy = 0;
    document.addEventListener("touchstart", function(e){
      var lb = $("[data-feed-lb]");
      if(!lb || !lb.classList.contains("open")) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, {passive:true});
    document.addEventListener("touchend", function(e){
      var lb = $("[data-feed-lb]");
      if(!lb || !lb.classList.contains("open") || !sx) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if(Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) feedStepLB(dx < 0 ? 1 : -1);
      sx = 0;
    }, {passive:true});

    function openFromHash(){
      var m = /^#post-(.+)$/.exec(location.hash);
      if(!m) return false;
      var list = feedVisible();
      for(var i=0;i<list.length;i++){
        if(list[i].getAttribute("data-post") === m[1]){ feedOpenLB(i, 0, false); return true; }
      }
      return false;
    }
    addEventListener("popstate", function(){ if(!openFromHash()) feedCloseLB(false); });
    if(/^#post-/.test(location.hash)) setTimeout(openFromHash, 60);

    var rt;
    addEventListener("resize", function(){ clearTimeout(rt); rt = setTimeout(layoutWall, 150); });
    addEventListener("load", layoutWall);
  }

  /* ------------------------------------------------ STICKY BAR PADDING */
  /* The sticky PDP buybar and cart total bar are position:fixed. Without
     these body classes the CSS cannot reserve space and they overlap the
     footer on mobile. */
  function stickyBarClasses(){
    if($("[data-product-root]")) document.body.classList.add("pdp-page");
    /* main-cart.liquid only renders .mcta when cart.item_count > 0, so its
       presence is the signal. */
    document.body.classList.toggle("has-mcta", !!$(".mcta"));
  }

  /* ------------------------------------------------------- GEO AMOUNTS */
  /* Editorial amounts only (shipping threshold, signup reward). Product
     prices come from Shopify Markets via the money filter, not from here.
     Region is taken from the active market's currency, not an IP lookup. */
  function applyGeoAmounts(root){
    var inr = (S.currency || "INR").toUpperCase() === "INR";
    $$("[data-inr][data-usd]", root || document).forEach(function(el){
      el.textContent = el.getAttribute(inr ? "data-inr" : "data-usd");
    });
  }
  window.AarushGeo = { apply: applyGeoAmounts };

  /* --------------------------------------------------------------- INIT */
  function ready(fn){ document.readyState!=="loading" ? fn() : document.addEventListener("DOMContentLoaded", fn); }
  ready(function(){
    $$("[data-year]").forEach(function(el){ el.textContent = new Date().getFullYear(); });
    updateCount();
    revealScan();
    stickyHeader();
    backToTop();
    heroSlider();
    hookScrollers();
    countUps();
    initProduct();
    markFavs();
    renderWishlist();
    applyGeoAmounts();
    seedAccordions();
    stickyBarClasses();
    initFeed();
    if(typeof window.AarushPage === "function"){ window.AarushPage(); }
  });
})();

/* Native dialog supplies focus containment and Escape dismissal. */
(function(){
  function initWelcomePopup(){
    var dialog=document.querySelector('[data-newsletter-popup]');
    if(!dialog || typeof dialog.showModal !== 'function') return;
    var key='aarush-welcome-offer-seen-v1';
    var preview=window.Shopify && window.Shopify.designMode;
    try{ if(!preview && (localStorage.getItem(key) || sessionStorage.getItem(key))) return; }catch(e){}
    var previousFocus=document.activeElement;
    dialog.querySelector('[data-close-newsletter]').addEventListener('click',function(){dialog.close();});
    dialog.addEventListener('click',function(e){
      var rect=dialog.getBoundingClientRect();
      if(e.target===dialog && (e.clientX<rect.left || e.clientX>rect.right || e.clientY<rect.top || e.clientY>rect.bottom)) dialog.close();
    });
    dialog.addEventListener('close',function(){if(previousFocus && previousFocus.isConnected) previousFocus.focus();});
    var front=dialog.querySelector('.nl-face--front');
    var back=dialog.querySelector('.nl-face--back');
    if(back) back.inert=true;
    var card=dialog.querySelector('[data-newsletter]');
    if(card && front && back) new MutationObserver(function(){
      var flipped=card.classList.contains('is-flipped');
      front.inert=flipped; back.inert=!flipped;
      if(flipped){var code=back.querySelector('button'); if(code) code.focus();}
    }).observe(card,{attributes:true,attributeFilter:['class']});
    dialog.showModal();
    if(!preview){
      try{localStorage.setItem(key,'1');}catch(e){try{sessionStorage.setItem(key,'1');}catch(e){}}
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initWelcomePopup);
  else initWelcomePopup();
})();
